import React, { useState } from 'react';

import cn from 'classnames';

import useWindowDimensions from 'Shared/hooks/useWindowDimensions';

import TriangleIcon from '../TriangleIcon/TriangleIcon';
import TreeView from './components/TreeView';
import { PADDING_FROM_TOP_PAGE_TO_TABLE } from './constants/constants';

function TableTree({ treeArr, setIsOpenSideBar, showPercent, titleColumn, dateColumnsPeriod }) {
  const { height: heightPage } = useWindowDimensions();

  const [showElements, setShowElements] = useState([]);

  const createArrValueBlock = (obj, baseLevel) => {
    const arrValueBlock = [obj.value];
    let hiddenRow = true;

    // if we have items in showElements then we make hiddenRow = false
    // for render table__table-body__row in not collapsed
    showElements.forEach((element) => {
      if (hiddenRow && element.id === obj.id) {
        hiddenRow = false;
        const arrValue = element.value.map((item) => ({ val: item.val }));
        arrValueBlock.push(arrValue);
      }
    });

    // render table__table-body__row in collapsed
    if (hiddenRow) {
      return arrValueBlock.map((item, index) => (
        <div
          key={index}
          onClick={setIsOpenSideBar}
          className={cn('table__table-body__row', { hidden_row: hiddenRow && baseLevel })}
        >
          {item.map((data, index) => (
            <div key={index} className="table__table-body__column">
              {data.val}
            </div>
          ))}
        </div>
      ));
    }

    // render table__table-body__row in not collapsed
    if (obj.children) {
      return [{ value: obj.value || dateColumnsPeriod.map(() => ({ val: '-' })) }, ...obj.children].map((item) =>
        createArrValueBlock(item)
      );
    } else if (obj.value) {
      arrValueBlock.push(obj.value);
    }

    const getDirection = (status) => {
      switch (status) {
        case 'positive':
          return 'up';
        case 'negative':
          return 'down';
        default:
          return 'default';
      }
    };

    return arrValueBlock.map((item, index) => (
      <div key={item.id || index} className="table__table-body__row">
        {item.map((data, index) => (
          <div key={data.id || index} className="table__table-body__column" onClick={setIsOpenSideBar}>
            {data.status && showPercent && <TriangleIcon direction={getDirection(data.status)} type={data.status} />}
            <span>{data.val || '-'}</span>
          </div>
        ))}
      </div>
    ));
  };

  return (
    <div className="table__table-body" style={{ maxHeight: heightPage - PADDING_FROM_TOP_PAGE_TO_TABLE }}>
      <div className="table__table-body__header">
        <div className="table__table-body__column column-first">{titleColumn}</div>
        {dateColumnsPeriod.map((date) => (
          <div key={date} className="table__table-body__column">
            {date}
          </div>
        ))}
      </div>
      <div className="table__table-body__body">
        {treeArr.map((treeItem) => (
          <div key={treeItem.id} className="table__table-body__row">
            <div className="table__table-body__column column-first table__tree-column">
              <div className="table__tree">
                <TreeView baseLevel={true} breakdown={[treeItem]} setShowElements={setShowElements} />
              </div>
            </div>
            <div className="table__table-body__value-block">{createArrValueBlock(treeItem, 'baseLevel')}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TableTree;
